import { render, staticRenderFns } from "./CustomerDetailsTabs.vue?vue&type=template&id=b48d6c46&"
import script from "./CustomerDetailsTabs.vue?vue&type=script&lang=js&"
export * from "./CustomerDetailsTabs.vue?vue&type=script&lang=js&"
import style0 from "./CustomerDetailsTabs.vue?vue&type=style&index=0&id=b48d6c46&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports